module.exports = __webpack_public_path__ + "static/media/3 barn owl night tattoo sleeve black and grey.1280x1721.ba698bf5.webp";